import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://harshitsharma.work";
const DEFAULT_IMAGE = `${SITE_URL}/og.png`;
const DEFAULT_TITLE =
  "Harshit Sharma | Product Designer Portfolio — UX/UI Case Studies";
const DEFAULT_DESCRIPTION =
  "Lead Product Designer (6+ years) specializing in UX/UI design and product strategy. Explore case studies, or get in touch for freelance and contract design work.";

// Every route renders one of these so each page gets its own title,
// description, canonical, and Open Graph/Twitter tags instead of all of
// them sharing whatever was hardcoded in public/index.html.
export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  noIndex = false,
}) {
  const resolvedTitle = title
    ? `${title} | Harshit Sharma`
    : DEFAULT_TITLE;
  const resolvedDescription = description || DEFAULT_DESCRIPTION;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDescription} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={resolvedDescription} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
